import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { Card } from "../components/ui/card";
import { CONDITIONS, ICON_MAP } from "../lib/conditions";
import { ArrowRight, BookOpen } from "lucide-react";

export default function ConditionsIndex() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <section className="bg-gradient-to-br from-slate-900 to-teal-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/10 text-[11px] font-semibold uppercase tracking-[0.2em]">
            <BookOpen className="w-3.5 h-3.5" /> Health Library
          </div>
          <h1 className="mt-4 font-heading text-4xl sm:text-5xl font-bold leading-tight">
            Conditions we help with
          </h1>
          <p className="mt-3 text-white/80 max-w-2xl">
            Plain-English explainers on common neurological & spine conditions, with expert criteria for when a second opinion can change your outcome.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CONDITIONS.map((c) => {
            const Icon = ICON_MAP[c.icon] || ICON_MAP.Brain;
            return (
              <Link
                key={c.slug}
                to={`/conditions/${c.slug}`}
                className="group"
                data-testid={`condition-card-${c.slug}`}
              >
                <Card className="p-5 border-slate-200 lift h-full flex flex-col">
                  <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${c.color} grid place-items-center text-white shadow-sm mb-4`}>
                    <Icon className="w-6 h-6"/>
                  </div>
                  <h3 className="font-heading font-semibold text-lg text-slate-900 leading-snug group-hover:text-teal-700 transition">
                    {c.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed line-clamp-3 flex-1">
                    {c.blurb}
                  </p>
                  <div className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-teal-700">
                    Read more <ArrowRight className="w-4 h-4"/>
                  </div>
                </Card>
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
}
